import React, { Fragment } from "react";

/**
 * Components
 */
import GuyPuzzlePath from "../../assets/svg/guy_puzzle.svg";
import GuyMoneyPath from "../../assets/svg/guy_money.svg";
import BaseButton from "../../components/base-button/base-button";
import useModal from "../../hooks/use-modal";
import API from "../../utils/api";

const ModelAlertSetupPayment = (props) => {
  const { closeModal } = useModal();
  const { makePayment, notToday, alert, scoreChanged } = props.modalProps;

  const _makePayment = async () => {
    try {
      await API.put(`/alerts/${alert.id}/dismiss`);
      makePayment();
    } catch (e) {
      console.log(e);
    }
  };

  const _closeModal = async () => {
    try {
      await API.put(`/alerts/${alert.id}/dismiss`);
      notToday();
    } catch (e) {
      console.log(e);
    }
    closeModal();
  };

  return (
    <Fragment>
      <div style={{ textAlign: "center" }}>
        <img
          src={scoreChanged ? GuyMoneyPath : GuyPuzzlePath}
          width={200}
          alt={"picture of a guy"}
        />
        <h1
          style={{
            color: "#272643",
            fontWeight: "lighter",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {scoreChanged ? "Great job!" : "Welcome back!"}
        </h1>
        <p>
          {scoreChanged
            ? "It seems like things might be in a good place for you! What do you think of making a payment towards your account?"
            : "Is now a good time to start a payment plan on your account? This is the first step to being Freede from debt."}
        </p>
        <BaseButton
          type="button"
          className="btn--primary"
          style={{ marginTop: "30px" }}
          onClick={_makePayment}
        >
          Make Payment
        </BaseButton>
        <p
          style={{ marginTop: "10px", cursor: "pointer" }}
          onClick={_closeModal}
        >
          Not today
        </p>
      </div>
    </Fragment>
  );
};

export default ModelAlertSetupPayment;
